//===============================
export const HTTP_CONSTANTS = {
  GET    : "get",
  PUT    : "put",
  POST   : "post",
  DELETE : "delete",
  TIMEOUT: 20000
};

// ==============================
// ROW PER PAGINATION OPTIONS
// ==============================
export const ROW_PER_PAGINATION_OPTIONS = [10, 20, 50, 100],
  LOCAL_PAGINATION_OPTIONS = [10, 50, 100, 150],
  STATUS_ALL = "all";

// ==============================
// REACT SELECT STYLES
// ==============================
export const REACT_STYLES = ({ type }) => ({
  multiValue: (base, state) => {
    return state.data.isFixed ? { ...base, opacity: "0.5" } : base;
  },
  multiValueLabel: (base, state) => {
    return state.data.isFixed
      ? { ...base, color: "#626262", paddingRight: 6 }
      : base;
  },
  multiValueRemove: (base, state) => {
    return state.data.isFixed ? { ...base, display: "none" } : base;
  },
  control: (base) => {
    return type === "error"
      ? {
          ...base,
          border   : "1px solid #c5064f",
          "&:hover": {
            borderColor: "#c5064f"
          },
          "&:focus": {
            borderColor: "#c5064f"
          }
        }
      : type === "warning"
        ? {
            ...base,
            border   : "1px solid #D8A20E",
            "&:hover": {
              borderColor: "#D8A20E"
            },
            "&:focus": {
              borderColor: "#D8A20E"
            }
          }
        : {
            ...base,
            border: "1px solid #d8d6de"
          };
  },
  dropdownIndicator: (base) => {
    return type === "error"
      ? { ...base, color: "#c5064f" }
      : type === "info"
        ? { ...base, color: "#D8A20E" }
        : { ...base, color: "#6e6b7b" };
  }
});

// ==============================
// INITIAL PAGINATION FOR DATA
// ==============================
export const INIT_PAGIN = { page: 1, limit: 50 };

// ==============================
// DATE_FORMAT_API
// ==============================
export const DATE_FORMAT_API = "YYYY-MM-DD";
export const DATE_PICKER_FORMAT = "YYYY-MM-DD hh:mm:ss A";

// ==============================
// DATE_FORMAT_VIEW
// ==============================
export const DATE_FORMAT_VIEW = "MMM DD, YYYY [at] hh:mm A";
export const DAYS_RANGE_ALLOWED = 35,
  LOGS_DAYS_RANGE_ALLOWED = 31;

// ==============================
// ALERT CONFIG
// ==============================
export const ALERT_CONFIG = {
  delete: {
    title            : "Are you sure?",
    text             : "This action cannot be undone.",
    icon             : "warning",
    confirmButtonText: "Yes, delete it!",
    showCancelButton : true
  },
  patch: {
    text             : "Are you sure you want to update?",
    icon             : "question",
    confirmButtonText: "Update",
    showCancelButton : true
  },
  post: {
    text            : "Are you sure you want to create?",
    icon            : "question",
    showCancelButton: true
  }
};

// ==============================
// HTTP SUCCESS MESSAGE CONFIG
// ==============================
export const HTTP_SUCCESS_MESSAGE_CONFIG = {
  delete: "Deleted!",
  patch : "Updated!",
  post  : "Created!"
};

// ==============================
// LANGUAGES SUPPORTED
// ==============================
export const LANGUAGES_SUPPORTED = [
  "de",
  "en",
  "es",
  "fr",
  "it",
  "pt",
  "ru",
  "vn",
  "cn",
  "ae"
];
